// #ux-redesign-start: PageContainer primitive (Paso 2)
// Wrapper único de pantalla. Reemplaza el `Card>CardBody>Card>CardHeader+CardBody`
// con la pildora naranja gigante de título (ej. la actual "Labor / Diagnostik").
//
// PORTABILIDAD: trasplantable a Web-Patients.
//
// USO:
//   <PageContainer title="Labor / Diagnostik" icon="microscope" subtitle="Übersicht">
//     {tableContent}
//   </PageContainer>
//
//   <PageContainer
//     title="Patient bearbeiten"
//     breadcrumb={[{ label: 'Patienten', to: '/admin/patients' }, { label: 'Bearbeiten' }]}
//     actions={<Button variant="primary">Speichern</Button>}
//   >
//     {form}
//   </PageContainer>
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import PropTypes from 'prop-types';

const PageContainer = ({
  title,
  subtitle,
  icon,
  breadcrumb,
  actions,
  children,
  bleed = false,
  className = '',
}) => {
  const classes = [
    'ds-page',
    bleed ? 'ds-page--bleed' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {breadcrumb && breadcrumb.length > 0 && (
        <nav className="ds-page__breadcrumb" aria-label="breadcrumb">
          <ol>
            {breadcrumb.map((item, i) => (
              <li key={i}>
                {item.to ? (
                  <a href={item.to}>{item.label}</a>
                ) : (
                  <span>{item.label}</span>
                )}
                {i < breadcrumb.length - 1 && (
                  <span className="ds-page__breadcrumb-sep" aria-hidden="true"> / </span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      )}
      {(title || actions) && (
        <header className="ds-page__header">
          <div className="ds-page__heading">
            {icon && (
              <span className="ds-page__icon" aria-hidden="true">
                {typeof icon === 'string' ? <i className={`icon-${icon}`} /> : icon}
              </span>
            )}
            <div>
              {title && <h1 className="ds-page__title">{title}</h1>}
              {subtitle && <p className="ds-page__subtitle">{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="ds-page__actions">{actions}</div>}
        </header>
      )}
      {/* #ux-redesign: si no hay chrome (header/breadcrumb), saltar el wrapper
          __body para que los selectores legacy `.ds-page > .X` matcheen sin
          un nivel extra. Util para vistas tipo Chat que necesitan que .chat-box
          sea hijo DIRECTO del PageContainer. */}
      {(title || actions || (breadcrumb && breadcrumb.length > 0)) ? (
        <div className="ds-page__body">
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
};

PageContainer.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    to: PropTypes.string,
  })),
  actions: PropTypes.node,
  children: PropTypes.node,
  bleed: PropTypes.bool,
  className: PropTypes.string,
};

export default PageContainer;
// #ux-redesign-end
